<template>
  <div></div>
</template>

<script>
export default {
  name: 'payali',
  created () {
    const result = this.$route.query.result
    const payDiv = document.getElementById('payDiv')
    if (payDiv) {
      document.body.removeChild(payDiv)
    }
    const div = document.createElement('div')
    div.id = 'payDiv'
    div.innerHTML = result
    document.body.appendChild(div)
    document
      .getElementById('payDiv')
      .getElementsByTagName('form')[0]
      .submit()
  }
}
</script>

<style scoped>
</style>
